import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProjectChartResult, Result } from 'app/models';
import { StartProjectDetailService, StartProjectService, TicketService } from 'app/services';
import { Utility } from 'app/shared';
import { Chart, registerables } from 'chart.js';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss']
})
export class ChartsComponent implements OnInit {

  @Input()
  public token: string;

  public result: Result = new Result();
  public ongoingProjects = new Array<ProjectChartResult>();

  constructor(
    private ticketService: TicketService,
    private translateService: TranslateService,
    private startProjectService: StartProjectService,
    private startProjectDetailService: StartProjectDetailService
  ) {
    this.token = '';
    this.result = new Result();
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    this.ticketService.getTicketStatusReport(this.token).then(result => {
      if (result.success === true) {

        const canvas = <HTMLCanvasElement>document.getElementById('ticketStatus');
        const ctx = canvas.getContext('2d');

        const doughnutChart = new Chart(ctx!, {
          type: 'doughnut',
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.4,
            plugins: {
              legend: {
                position: 'right',
              },
              title: {
                display: false,
              }
            }
          },
          data: {
            labels: result.data.map(r => this.translateService.instant(r.name)),
            datasets: [
              {
                data: result.data.map(r => r.quantity),
                backgroundColor: ['#6c757d', '#17a2b8', '#007bff', '#ffc107', '#dc3545'],
                borderWidth: 0,
              }
            ]
          }
        });
      } else {
        this.result = result;
      }
    });

    this.ticketService.getTicketPriorityReport(this.token).then(result => {
      if (result.success === true) {

        const canvas = <HTMLCanvasElement>document.getElementById('ticketPriority');
        const ctx = canvas.getContext('2d');

        const priorityChart = new Chart(ctx!, {
          type: 'doughnut',
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.4,
            plugins: {
              legend: {
                position: 'right',
              },
              title: {
                display: false,
              }
            }
          },
          data: {
            labels: result.data.map(r => this.translateService.instant(r.name)),
            datasets: [
              {
                data: result.data.map(r => r.quantity),
                backgroundColor: ['#6c757d', '#17a2b8', '#007bff', '#ffc107', '#dc3545'],
                borderWidth: 0,
              }
            ]
          }
        });
      } else {
        this.result = result;
      }
    });

    this.ticketService.getTicketsPerProjectReport(null, this.token).then(result => {
      if (result.success === true) {

        const canvas = <HTMLCanvasElement>document.getElementById('allTickets');
        const ctx = canvas.getContext('2d');

        const colors = Array<string>();
        result.data.forEach(() => {
          colors.push(this.getRandomColor());
        });
        const projectChartAll = new Chart(ctx!, {
          type: 'bar',
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.4,
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: false,
              }
            }
          },
          data: {
            labels: result.data.map(r => this.translateService.instant(r.name)),
            datasets: [
              {
                data: result.data.map(r => r.quantity),
                backgroundColor: colors,
                borderWidth: 0,
              }
            ]
          },
        });
      } else {
        this.result = result;
      }
    });

    this.ticketService.getTicketsPerProjectReport(false, this.token).then(result => {
      if (result.success === true) {

        const canvas = <HTMLCanvasElement>document.getElementById('activeTickets');
        const ctx = canvas.getContext('2d');

        const colors = Array<string>();
        result.data.forEach(() => {
          colors.push(this.getRandomColor());
        });
        const projectChart = new Chart(ctx!, {
          type: 'bar',
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.4,
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: false,
              }
            }
          },
          data: {
            labels: result.data.map(r => this.translateService.instant(r.name)),
            datasets: [
              {
                data: result.data.map(r => r.quantity),
                backgroundColor: colors,
                borderWidth: 0,
              }
            ]
          },
        });
      } else {
        this.result = result;
      }
    });

    this.ticketService.getTicketsPerProjectReport(true, this.token).then(result => {
      if (result.success === true) {

        const canvas = <HTMLCanvasElement>document.getElementById('closedTickets');
        const ctx = canvas.getContext('2d');

        const colors = Array<string>();
        result.data.forEach(() => {
          colors.push(this.getRandomColor());
        });
        const projectChart = new Chart(ctx!, {
          type: 'bar',
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.4,
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: false,
              }
            }
          },
          data: {
            labels: result.data.map(r => this.translateService.instant(r.name)),
            datasets: [
              {
                data: result.data.map(r => r.quantity),
                backgroundColor: colors,
                borderWidth: 0,
              }
            ]
          },
        });
      } else {
        this.result = result;
      }
    });

    this.startProjectService.getAllStartProjectReport().then(result => {
      if (result.success === true) {
        const canvas = <HTMLCanvasElement>document.getElementById('projectStatus');
        const ctx = canvas.getContext('2d');
        const projectStatus = new Chart(ctx!, {
          type: 'doughnut',
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.4,
            plugins: {
              legend: {
                position: 'right'
              },
              title: {
                display: false,
              }
            }
          },
          data: {
            labels: result.data.map(r => this.translateService.instant(r.name)),
            datasets: [
              {
                data: result.data.map(r => r.quantity),
                backgroundColor: ['#dc3545', '#28a745'],
                borderWidth: 0,
              }
            ]
          }
        });
      } else {
        this.result = result;
      }
    });

    this.startProjectDetailService.getAllStartProjectDetailReport(Utility.getTokenType()).then(result => {
      if (result.success === true) {
        this.ongoingProjects = result.data;
        setTimeout(() => {
          result.data.forEach(item => {
            const canvas = <HTMLCanvasElement>document.getElementById('ongoingProjects' + item.startProjectId);
            const ctx = canvas.getContext('2d');

            const ongoingProjects = new Chart(ctx!, {
              type: 'doughnut',
              options: {
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1.4,
                plugins: {
                  legend: {
                    position: 'right'
                  },
                  title: {
                    display: false,
                  }
                }
              },
              data: {
                labels: [
                  this.translateService.instant('Remained'),
                  this.translateService.instant('Done')
                ],
                datasets: [
                  {
                    data: [item.remainedTasks, item.doneTasks],
                    backgroundColor: ['#dc3545', '#28a745'],
                    borderWidth: 0,
                  }
                ]
              }
            });
          });
        }, 500);
      } else {
        this.result = result;
      }
    });
  }

  private getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
}
